import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import Icon from "ds/components/Icon";
import TextEllipsis from "ds/components/TextEllipsis";
import TooltipInfo from "ds/components/TooltipInfo";
import Typography from "ds/components/Typography";
import { IconComponent } from "types/Icon";

type TableHeadInteractiveColumnTitleProps =
  | {
      title: string;
      icon?: IconComponent;
      iconOnly?: boolean;
      tooltip?: string;
      allowsSorting?: false;
      sortIcon?: unknown;
      onSort?: unknown;
    }
  | {
      title: string;
      icon?: IconComponent;
      iconOnly?: boolean;
      tooltip?: string;
      allowsSorting: true;
      sortIcon: IconComponent;
      onSort: () => void;
    };

const TableHeadInteractiveColumnTitle = ({
  title,
  icon,
  iconOnly,
  tooltip,
  allowsSorting,
  sortIcon,
  onSort,
}: TableHeadInteractiveColumnTitleProps) => {
  return (
    <Box align="center" gap="small">
      {icon && <Icon src={icon} color="secondary" noShrink />}

      {iconOnly && <span className="sr-only">{title}</span>}
      {!iconOnly && (
        <TextEllipsis tooltip={title}>
          {(props) => (
            <Typography color="secondary" tag="span" variant="p-t7" {...props}>
              {title}
            </Typography>
          )}
        </TextEllipsis>
      )}

      {tooltip && (
        <TooltipInfo standardIconColor="secondary" widthMode="maxWidthSm">
          {tooltip}
        </TooltipInfo>
      )}

      {allowsSorting && (
        <ButtonIcon
          variant="ghost"
          icon={sortIcon}
          onPress={onSort}
          aria-label={`Sort by ${title}`}
        >
          Toggle sort
        </ButtonIcon>
      )}
    </Box>
  );
};

TableHeadInteractiveColumnTitle.displayName = "DS.Table.Head.InteractiveColumn.Title";

export default TableHeadInteractiveColumnTitle;
